/*
 * @Description: 时间相关的一些方法
 */
import { isDate, isString } from 'lodash-es'

/**
 * @description: 将时间格式的字符串专户为时间格式的数据
 * @param str 时间格式的字符串 日期支持8位年月日，也可以是分隔符分隔的字符串。如下：
 * "2019-11-06 12:00:00"
 * "2019/11/06 12:00:00"
 * "20191106 12:00:00"
 * @return: Date
 */
export function strToDate(str) {
  let dt = str.split(' ')
  let hh = 0
  let mm = 0
  let ss = 0
  let year
  let month
  let dd
  let hmsStr
  let hms
  let ymdStr = dt[0]
  if (dt.length === 2) {
    hmsStr = dt[1]
  }
  let matchD = ymdStr.match(/^(\d{4})\D(\d{1,2})\D(\d{1,2})$/)
  if (matchD) {
    year = matchD[1]
    month = matchD[2]
    dd = matchD[3]
  } else {
    if (ymdStr.length === 8) {
      year = ymdStr.substring(0, 4)
      month = ymdStr.substring(4, 6)
      dd = ymdStr.substring(6, 8)
    }
  }
  if (hmsStr) {
    hms = hmsStr.match(/^(\d{2})\D(\d{2})\D(\d{2})/)
    hh = hms[1]
    mm = hms[2]
    ss = hms[3]
  }
  return new Date(year, month - 1, dd, hh, mm, ss)
}

/**
 * @description: 按照指定类型将日期格式化，
 * @param date 日期对象，日期时间戳1573019884890，标准格式时间字符串"2019/01/01 12:11:11"
 * @return: String 格式化的时间字符串
 */
export function dateFormat(date, format = 'yyyy-MM-dd') {
  if (!isDate(date)) {
    date = new Date(date)
  }
  if (date.getTime()) {
    var o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }

    for (var k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
      }
    }
    return format
  } else {
    return ''
  }
}

/**
 * @description 时间格式转为时间戳
 * @param time   '09:12:20'
 */
export function timeToTimestamp(time) {
  let timeArr = time.split(':')
  let hour = timeArr[0]
  let min = timeArr[1]
  let sec = timeArr[2]
  return Number(hour) * 3600 + Number(min) * 60 + Number(sec)
}

/**
 * @description 时间戳转为时间格式  时分秒
 * @param timestamp
 */
export function timestampToTime(timestamp) {
  let hours = (timestamp % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  let minutes = (timestamp % (1000 * 60 * 60)) / (1000 * 60)
  let seconds = (timestamp % (1000 * 60)) / 1000
  let h = hours < 10 ? '0' + hours : hours
  let m = minutes < 10 ? '0' + minutes : minutes
  let s = seconds < 10 ? '0' + seconds : seconds
  return hours + ':' + minutes + ':' + seconds
}

/**
 *  @description 时间范围转换
 *  @param time
 */
export function parseTimeRange(time) {
  return {
    from: string2timestamp(time.from),
    to: string2timestamp(time.to)
  }
}

/**
 * 字符串转时间戳，相对时间计算。 仅支持天，时分秒的转换
 * @param {} str
 * @returns
 */
function string2timestamp(str) {
  if (!str) {
    return undefined
  }
  if (isString(str) && str.indexOf('now') !== -1) {
    if (str === 'now') {
      return new Date().getTime()
    } else {
      const unit = str.charAt(str.length - 1)
      const num = str.substring('now-'.length, str.length - 1)
      let duration = 0
      switch (unit) {
        case 's':
          duration = num * 1000
          break
        case 'm':
          duration = num * 60 * 1000
          break
        case 'h':
          duration = num * 60 * 60 * 1000
          break
        case 'd':
          duration = num * 24 * 60 * 60 * 1000
          break
      }
      return new Date().getTime() - duration
    }
  } else {
    return new Date(str).getTime()
  }
}



// WEBPACK FOOTER //
// ./src/components/SimbartUI/utils/date.js